<template>
  <div class="noDisc">
    <div>
      <img src="../..//assets/img/ukey404.png"/>
    </div>
    <div>
      <p>尚未插入税盘</p>
      <p>尚未插入税盘，请插入税盘后重试</p>
    </div>
  </div>
</template>
<script>
// import { ukeyBoxRequest } from '@services'
// import { Notify } from 'vant'
export default {
  data () {
    return {

    }
  },
  async mounted () {
    // if (sessionStorage.boxCode) {
    //   let data = await ukeyBoxRequest.ukeyBox.getValidDevice({ boxCode: this.boxCode })
    //   if (data.success) {
    //     if (data.result) {
    //       this.$router.push('/ukey')
    //     }
    //   } else {
    //     Notify({ type: 'danger', message: data.message })
    //   }
    // }
  }
}
</script>
<style scoped lang="less">
.noDisc{
  height: 100%;
  background: #fff;
  padding-top: 280px;
  box-sizing: border-box;
  div{
    width: 702px;
    text-align: center;
    margin: 0px auto 190px;
  }
  div:last-of-type{
    p:first-of-type{
      font-size: 48px;
      color: #3E4966;
      text-align: center;
      font-weight: bold;
    }
    p:last-of-type{
      font-size: 32px;
      font-weight: 400;
      margin-top: 32px;
      color: #9EA9B9;
    }
  }
}
</style>
